module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/20-c04f455fbae66d84f064385d4c7826cc.png";